import React, { Component } from 'react';
import PropTypes from "prop-types"

export class Image extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isVisible: true,
            isLoading: false,
            source: props.source
        };
        // this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.calculateImageVisible = this.calculateImageVisible.bind(this)
        this.handleError = this.handleError.bind(this);

    }


    // componentWillReceiveProps(nextProps){
    //     this.setState({source: nextProps.source})
    // }
    static getDerivedStateFromProps(nextProps, prevState){
        if(typeof(nextProps.source) !== "undefined" && nextProps.source !== null){
            if(nextProps.source !== prevState.source) {
                return {...prevState, source: nextProps.source}
            }else{
                return prevState;
            }
        }else{
            return prevState;
        }
    }

    calculateImageVisible() {
        
    }
    handleError(event){
        if(typeof(this.props.defaultSrc) !== "undefined" && this.props.defaultSrc !== null){
            this.setState({source: this.props.defaultSrc})
        }else{
            this.setState({source: require("../images/icon-missing-asset-red.svg")})
        }
    }

    cancelImageLoad() {
        this.setState({isVisible: false});
    }

    loadImage() {
        this.setState({isVisible: true, isLoading: true});
    }

    render() {
        return (
            <img alt='' ref={img => this.img = img} src={this.state.isVisible ? this.state.source : ''} onError={this.handleError} {...this.props}/>
        );
    }
}

Image.propTypes={
    source: PropTypes.string.isRequired,
    defaultSrc: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/common/components/image.jsx